import { PrintProviderType, PrintSettingsType } from '../types/common.types';
import { getObjectById } from './getObjectById';

export const formatDataId = (
  data: ({ id: string } & Record<string, any>)[]
): string[] => {
  if (!data) return [];

  return data.map((d) => d.id);
};

export const formatPrintProviderData = (
  printProviderData: PrintProviderType
) => ({
  ...printProviderData,
  documentPrintSettings: {
    ...printProviderData.documentPrintSettings,
    printOptions: formatDataId(
      printProviderData?.documentPrintSettings?.printOptions
    ),
    postProcessingOptions: formatDataId(
      printProviderData?.documentPrintSettings?.postProcessingOptions
    )
  },
  drawingPrintSettings: {
    ...printProviderData?.drawingPrintSettings,
    formatGroups: formatDataId(
      printProviderData?.drawingPrintSettings?.formatGroups
    ),
    printOptions: formatDataId(
      printProviderData?.drawingPrintSettings?.printOptions
    ),
    postProcessingOptions: formatDataId(
      printProviderData?.drawingPrintSettings?.postProcessingOptions
    )
  }
});

export const formatDefault = (
  printProvider: PrintProviderType,
  printSettings: PrintSettingsType
): PrintProviderType => ({
  ...printProvider,
  documentPrintSettings: {
    ...printProvider?.documentPrintSettings,
    defaultPrintOption:
      printSettings?.documentPrintSettings?.defaultPrintOption,
    defaultPostProcessingOption:
      printSettings?.documentPrintSettings?.defaultPostProcessingOption,
    printOptions: [
      getObjectById(
        printSettings?.documentPrintSettings?.printOptions,
        printSettings?.documentPrintSettings?.defaultPrintOption
      )
    ],
    postProcessingOptions: [
      getObjectById(
        printSettings?.documentPrintSettings?.postProcessingOptions,
        printSettings?.documentPrintSettings?.defaultPostProcessingOption
      )
    ]
  },
  drawingPrintSettings: {
    ...printProvider?.drawingPrintSettings,
    defaultFormatGroup: printSettings?.drawingPrintSettings?.defaultFormatGroup,
    defaultPostProcessingOption:
      printSettings?.drawingPrintSettings?.defaultPostProcessingOption,
    defaultPrintOption: printSettings?.drawingPrintSettings?.defaultPrintOption,
    printOptions: [
      getObjectById(
        printSettings?.drawingPrintSettings?.printOptions,
        printSettings?.drawingPrintSettings?.defaultPrintOption
      )
    ],
    postProcessingOptions: [
      getObjectById(
        printSettings?.drawingPrintSettings?.postProcessingOptions,
        printSettings?.drawingPrintSettings?.defaultPostProcessingOption
      )
    ],
    formatGroups: [
      getObjectById(
        printSettings?.drawingPrintSettings?.formatGroups,
        printSettings?.drawingPrintSettings?.defaultFormatGroup
      )
    ]
  }
});
